import { z } from 'zod'

import {
  ActiveCampaignListSchema,
  ActiveCampaignFieldsSchema,
} from 'shared/api/common/schemas/activeCampaign'

export const ActiveCampaignSchemas = {
  getLists: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: ActiveCampaignListSchema,
  },
  getFields: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: ActiveCampaignFieldsSchema,
  },
}
